const REGISTER_MODAL = 'pinata/Modal/REGISTER_MODAL'
const DESTROY_MODAL = 'pinata/Modal/DESTROY_MODAL'

const SHOW_MODAL = 'pinata/Modal/SHOW_MODAL'
const HIDE_MODAL = 'pinata/Modal/HIDE_MODAL'

export const registerModal = modal => ({
  type: REGISTER_MODAL,
  meta: { modal },
})

export const destroyModal = modal => ({
  type: DESTROY_MODAL,
  meta: { modal },
})

export const showModal = modal => ({
  type: SHOW_MODAL,
  meta: { modal },
  payload: { visible: true },
})

export const hideModal = modal => ({
  type: HIDE_MODAL,
  meta: { modal },
  payload: { visible: false },
})

const defaultModal = {
  visible: false,
}

const modal = (state = defaultModal, { type, payload }) => {
  switch (type) {
    case REGISTER_MODAL:
    case SHOW_MODAL:
    case HIDE_MODAL:
      return { ...state, ...payload }

    default:
      return state
  }
}

const defaultReducer = {}

const reducer = (state = defaultReducer, { type, meta, payload }) => {
  switch (type) {
    case REGISTER_MODAL:
    case SHOW_MODAL:
    case HIDE_MODAL:
      return {
        ...state,
        [meta.modal]: modal(state[meta.modal], { type, payload }),
      }

    case DESTROY_MODAL: {
      const { [meta.modal]: toDestroy, ...newState } = state
      return { ...newState }
    }
    default: {
      return state
    }
  }
}

export default reducer
